<template>
  <div class="Team Page">
    <div class="Team__text" v-html="page[lang].text" />
  </div>
</template>

<script>
import Page from '@/core/mixins/Page'

export default {
  name: 'Team',
  mixins: [Page],
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Team

  strong
    font-weight 100
    margin-top 30px
    display inline-block

  &__text
    font-size 18px
    font-weight 500
    line-height 28px
    letter-spacing .05em
    max-width 800px
    p
      padding-left 40px

</style>
